
    __webpack_require__.initializeExposesData = {
  moduleMap: {
  "./PatientReception": () => {
return Promise.all(/*  | __federation_expose_PatientReception */ [__webpack_require__.e("787"), __webpack_require__.e("865"), __webpack_require__.e("802"), __webpack_require__.e("155")]).then(() => (() => (__webpack_require__(236))));
},
"./ProfessorSchedule": () => {
return Promise.all(/*  | __federation_expose_ProfessorSchedule */ [__webpack_require__.e("787"), __webpack_require__.e("865"), __webpack_require__.e("929"), __webpack_require__.e("673")]).then(() => (() => (__webpack_require__(5016))));
},
"./ProfessorScheduleAdmin": () => {
return Promise.all(/*  | __federation_expose_ProfessorScheduleAdmin */ [__webpack_require__.e("787"), __webpack_require__.e("865"), __webpack_require__.e("568"), __webpack_require__.e("974")]).then(() => (() => (__webpack_require__(3667))));
},
"./AppointmentCalendar": () => {
return Promise.all(/*  | __federation_expose_AppointmentCalendar */ [__webpack_require__.e("787"), __webpack_require__.e("865"), __webpack_require__.e("739"), __webpack_require__.e("558")]).then(() => (() => (__webpack_require__(2177))));
},
},
  shareScope: "default",
};
__webpack_require__.getContainer = __webpack_require__.getContainer || function() { throw new Error("should have __webpack_require__.getContainer") };__webpack_require__.initContainer = __webpack_require__.initContainer || function() { throw new Error("should have __webpack_require__.initContainer") };